import { render, staticRenderFns } from "./GlobalDashboardColumnChart.vue?vue&type=template&id=20fc48cc&scoped=true&"
import script from "./GlobalDashboardColumnChart.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardColumnChart.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboardColumnChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GlobalDashboardColumnChart.vue?vue&type=style&index=1&id=20fc48cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc48cc",
  null
  
)

export default component.exports